
				var addMethods = require("../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["normalize","mean","hyperGeometricTest","ttest","calculateEnrichedSignatures","clusterActivities","calculateVolcanoSignatures","calculateEnrichedGenes","epsilon","arrayMin","arrayMax"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "00891c84f0cc5d583768.worker.js", { name: "[hash].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			